<!--
 * @Author: fengqianhui
 * @Date: 2024-01-08 14:36:16
 * @LastEditors: fengqianhui fengqianhui@wedobest.com.cn
 * @LastEditTime: 2024-06-17 11:03:55
 * @FilePath: \landingpage\src\views\build\components\TableView.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <table class="table-default" v-if="!isMobile">
    <thead>
      <tr>
        <th v-for="header in transposedColumns" :key="header.key">{{ header.title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td v-for="(value, key) in validatedTransposedData[0] || {}" :key="key">
          <div v-if="value == 1" class="icon-wrap">
            <svg-icon iconClass="use" className="tableIcon"></svg-icon>
            <br />
            启用
          </div>
          <div v-else-if="value == 0" class="icon-wrap">
            <svg-icon iconClass="unuse" className="tableIcon"></svg-icon>
            <br />
            未启用
          </div>
          <div v-else>
            {{ value }}
          </div>
        </td>
      </tr>
      <tr>
        <td v-for="(value, key) in validatedTransposedData[1] || {}" :key="key" style="border-bottom: none">{{ value }}</td>
      </tr>
    </tbody>
  </table>
  <a-table :dataSource="tableList" :columns="columns" :pagination="false" v-else>
    <template #bodyCell="{ column, text }">
      <template v-if="column.dataIndex == 'value'">
        <div v-if="text == '0'">
          <svg-icon iconClass="unuse" className="tableIcon"></svg-icon>
          未启用
        </div>
        <div v-if="text == '1'">
          <svg-icon iconClass="use" className="tableIcon"></svg-icon>
          启用
        </div>
      </template>
      <template v-if="column.dataIndex == 'remark'">
        <div class="remark">
          <div v-if="text == '' || text == null">--</div>
          <div v-else>{{ text }}</div>
        </div>
      </template>
    </template>
  </a-table>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue';
import { buildResult } from '../hooks/useResult';
import { useOriginDataStore } from '@/stores/originDataStore';
const { isMobile } = buildResult();
const store = useOriginDataStore();
const tableList = computed(() => store.data?.funcList);
const columns = [
  {
    title: '功能',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '状态',
    dataIndex: 'value',
    key: 'value',
  },
  {
    title: '详情',
    dataIndex: 'remark',
    key: 'remark',
  },
];
const transposedColumns = computed(() => {
  const cols = [
    {
      title: '功能',
      dataIndex: 'menu',
      key: 'menu',
    },
  ];
  if (tableList) {
    tableList.value?.forEach((item) => {
      cols.push({
        title: item.key,
        dataIndex: item.key,
        key: item.key,
      });
    });
  }
  return cols;
});
const transposedData = computed(() => {
  if (tableList) {
    const data = [
      {
        menu: '状态',
        ...tableList?.value?.reduce((acc, current) => ({ ...acc, [current.key]: current.value }), {}),
      },
      {
        menu: '详情',
        ...tableList?.value?.reduce((acc, current) => ({ ...acc, [current.key]: current.remark || '/' }), {}),
      },
    ];
    return data;
  }
});
const validatedTransposedData = computed(() => {
  const defaultData = [{}, {}];
  if (!transposedData.value || transposedData.value.length < 2) {
    return defaultData;
  }
  return transposedData.value;
});
</script>
<style lang="less">
.table-default {
  border: 1px solid rgba(219, 224, 237, 1);
  background: rgba(255, 255, 255, 1);
  font-size: 14px;
  text-align: center;
  width: 100%;
  .icon-wrap {
    text-align: center;
  }
  table {
    width: 100%; /* 表格宽度是响应式的，占满容器宽度 */
    border-spacing: 0; /* 移除单元格之间的间距 */
    border-collapse: collapse; /* 合并单元格边框 */
  }
  thead {
    background-color: #fafafa; /* 表头背景色 */
  }
  th,
  td {
    padding: 16px; /* 单元格内边距 */
    border-bottom: 1px solid #f0f0f0; /* 单元格底部边框线 */
    text-align: center;
  }
  tr:hover {
    background-color: #f5f5f5; /* 鼠标悬停时行高亮显示 */
  }

  /* 自定义 SVG 图标大小和颜色 */
  .tableIcon {
    width: 14px;
    height: 14px;
    fill: currentColor; /* 可以根据图标进行颜色调整 */
    vertical-align: middle;
    margin-right: 8px; /* 图标与文字之间的间距 */
  }
}
.remark {
  max-width: 30vw;
}
</style>
